export default __webpack_public_path__ + "static/media/menu5_hl.39d30e31.png";